import React from 'react';
import { Input, SvgIcon, SearchActionButton } from 'seduo-ui';
import classNames from 'classnames';
import withSizes from 'react-sizes';
import { MEDIUM_DEVICES } from 'seduo-ui/constants';
export class SearchInput extends React.PureComponent {
    constructor(props) {
        super(props);
        this.handleScroll = () => {
            const { isMobile } = this.props;
            if (isMobile) {
                this.inputRef.current.blur();
            }
        };
        this.handleChange = (value) => {
            const { onChange } = this.props;
            onChange(value);
        };
        this.handleToggle = () => {
            const { onToggle, isMobile } = this.props;
            onToggle(isMobile ? true : document.activeElement === this.inputRef.current);
        };
        this.inputRef = React.createRef();
    }
    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    }
    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }
    render() {
        const { placeholder, value, onKeyDown, onClear, isMobile } = this.props;
        return (<div className="search__wrapper">
                <div className="search__icon-wrapper">
                    <SvgIcon kind="Search" className={classNames('search__icon')}/>
                </div>
                <Input innerRef={this.inputRef} placeholder={placeholder} onChange={(event) => this.handleChange(event.currentTarget.value)} onFocus={this.handleToggle} onBlur={this.handleToggle} onKeyDown={onKeyDown} type="search" value={value} className={classNames('search__input js-search-input')}/>
                <SearchActionButton onClick={onClear} inputValueSize={value.length} isMobile={isMobile}/>
            </div>);
    }
}
SearchInput.defaultProps = {
    value: '',
};
const mapSizesToProps = ({ width }) => ({
    isMobile: width < MEDIUM_DEVICES,
});
export default withSizes(mapSizesToProps)(SearchInput);
